module.exports = __webpack_public_path__ + "static/media/video_image3.26e2b485.png";